<template>
  <section class="classifiedRecommendation">
        <h2><div class="float-left">快速入口</div><div class="float-left" v-if="loginstatus"><span>以下优先根据您的学习兴趣推荐</span><span class="update-love" @click="updateLove">更改兴趣 ></span></div><span class="float-right more-curriculum" @click="gotoAllSearch">更多课程</span></h2>
        <div>
            <ul>
                <li class="float-left" v-for="(item, index) in data" :key="index" :ref="item.code">
                    <div v-if="index !== 1" @click="gotoSearch(item.parentcode, item.code, item.name)">
                        {{item.name}}
                    </div>
                    <div v-else @click="gotoTest">
                        董秘题库
                    </div>
                </li>
                <!-- <li class="float-left">市值管理</li>
                <li class="float-left">职场提升</li>
                <li class="float-left">编程与开发</li>
                <li class="float-left">互联网营销</li>
                <li class="float-left">创业创新</li> -->
            </ul>
        </div>
    </section>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {getIndexCategory} from 'api/indexApi'
export default {
    name: 'classifiedRecommendation',
    data() {
        return {
            data: [],
            loginstatus: this.user().isLogin
        }
    },
    mounted() {
        this.setLoading(true)      
        getIndexCategory({
            data: {},
            success: data=> {
                this.setLoading(false)
                this.data = data.data.content
            },
            error: data => {
                this.setLoading(false)
                this.$message.error(data.msg)
            }
        })

    },
    methods: {
        gotoSearch(parentcode, name, title) {
            this.$router.push({name: 'Search', query: {catecode: parentcode, typeData: name, title: title}})
        },
        gotoAllSearch() {
            this.$parent.gotoAllSearch()
        },
        updateLove() {
            this.$parent.getInterestPopu()
        },
        gotoTest() {
            // this.$router.push({
            //     name: 'StartTopic'
            // })
            window.open("//ke.capwhale.com/organ?hostid=1100243&tabs=5",'_blank')
        },
        ...mapActions(['setLoading']),
        ...mapGetters(['user'])
    },
    watch: {
        userLoginStatus() {
            // 登录状态发生变化
            this.loginstatus = this.user().isLogin
        }
    },
    computed: {
        userLoginStatus() {
            return this.user().isLogin;
        }
    }
    
}
</script>

<style lang="scss" type="text/scss">
.classifiedRecommendation {
    h2 {
        overflow: hidden;
        span {
            margin-left: 10px;
            font-size: 14px;
            color: #999999;
            &.update-love {
                color: #409EFF;
                cursor: pointer;
            }
        }
    }
    ul {
        margin: 0 -12px 0 0;
        overflow: hidden;
        li {
            margin-right: 23px;
            width: 177px;
            height: 100px;
            text-align: center;
            font-size: 20px;
            font-weight: 500;
            line-height: 100px;
            color: #fff;
            cursor: pointer;

            @for $i from 1 through 6 {
                &:nth-child(#{$i}) {
                    background: url('../../../../common/images/index/classifiedRecommendation-'+$i+'.png');
                    background-size: 100%;
                }
            }

            &:nth-child(6) {
                margin-right: 0;
            }

        }

    }
     
}
</style>